import { Injectable } from '@angular/core';
import { LoginService } from './login/login.service';

@Injectable({
  providedIn: 'root'
})

export class AppMenuService {

	private Jsn:any 

	constructor(private loginService: LoginService){
		
	}

	getAppMenus() {
		const profile:string=this.loginService.getVariableSesion("profile");
		return this.getMenu(profile);
	}

	getMenu(profile:string)
	{
		// profile = 'Compras'
		switch (profile) {

			case "Administrador":{
				this.Jsn = [
					{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'url': '/proveedores'
					},
					{
						'icon': 'fa-solid fa-list-check',
						'title': 'Aprobaciones',
						'url': '/aprobaciones'
					},
					{
						'icon': 'fa-solid fa-cart-shopping',
						'title': 'Compras',
						'url': '/compras',
						'submenu': [	
							{
								'title': 'Ordenes Compra',
								'url': 'compras/lista-oc'
							},
							{
								'title': 'Solicitudes',
								'url': 'compras/solicitudes'
							},
							// {
							// 	'title': 'Aprobaciones',
							// 	'url': 'compras/aprobaciones'
							// },
						]
					},
					{
						'icon': 'fa-solid fa-address-book',
						'title': 'Lista Sat',
						'url': '/lista-sat'
					},
				]
				break;
			}

			case "Validador":{
				this.Jsn = [
					{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'submenu': [
							{
								'title': 'Proveedores',
								'url': '/proveedores'
							},
							{
								'title': 'Proveedores por validar',
								'url': '/proveedores/validar'
							}
						]
						
					}
				]
				break;
			}

			case "Solicitante":{
				this.Jsn = [
					{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'url': '/proveedores',
					},
					/*{
						'icon': 'fa-solid fa-cart-shopping',
						'title': 'Compras',
						'url': '/compras',
						'submenu': [
							{
								'title': 'Solicitudes de Compra',
								'url': 'compras/solicitudes'
							},
							{
								'title': 'Pre-Ordenes Compra',
								'url': 'compras/solicitudes-pre-compra'
							},
							{
								'title': 'Ordenes Compra',
								'url': 'compras/lista-oc'
							},
						]
					},*/
				]
				break;
			}

			case "Pagos": {
				this.Jsn = [
					{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores Alta Banco',
						'url': '/proveedores/proveedores-lista-banco'
					},
					{
						'icon': 'fa-solid fa-credit-card',
						'title': 'Reportes',
						'url': '/cuentas-externas',
						'submenu': [	
							{
								'title': 'Cuentas Externas Nacionales',
								'url': 'reporte/cuentas-externas'
							},
							{
								'title': 'Cuentas Internas Nacionales',
								'url': 'reporte/cuentas-internas'
							},
						]
					}
				]
				break;
			}

			case "Contraloría":{
				this.Jsn = [
					{
						'icon': 'fa-solid fa-list-check',
						'title': 'Aprobaciones',
						'url': '/aprobaciones'
					},
				]
				break;
			}

			case "Autorizador":{
				this.Jsn = [
					{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'url': '/proveedores'
					},
					{
						'icon': 'fa-solid fa-list-check',
						'title': 'Aprobaciones',
						'url': '/aprobaciones'
					},
					{
						'icon': 'fa-solid fa-address-book',
						'title': 'Lista Sat',
						'url': '/lista-sat'
					},
					/*{
						'icon': 'fa-solid fa-cart-shopping',
						'title': 'Compras',
						'url': '/compras',
						'submenu': [
							{
								'title': 'Solicitudes de Compra',
								'url': 'compras/solicitudes-por-aprobar'
							},
							{
								'title': 'Pre-Ordenes Compra',
								'url': 'compras/solicitudes-pre-compra'
							},
							{
								'title': 'Ordenes Compra',
								'url': 'compras/lista-oc'
							},
						]
					},*/
				]
				break;
			}

			case "Autorizador Funcional":{
				this.Jsn = [
					/*{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'url': '/proveedores'
					},
					{
						'icon': 'fa-solid fa-list-check',
						'title': 'Aprobaciones',
						'url': '/aprobaciones'
					},
					{
						'icon': 'fa-solid fa-address-book',
						'title': 'Lista Sat',
						'url': '/lista-sat'
					},
					{
						'icon': 'fa-solid fa-cart-shopping',
						'title': 'Compras',
						'url': '/compras',
						'submenu': [
							{
								'title': 'Solicitudes de Compra',
								'url': 'compras/solicitudes-por-aprobar'
							},
							{
								'title': 'Pre-Ordenes Compra',
								'url': 'compras/solicitudes-pre-compra'
							},
							{
								'title': 'Ordenes Compra',
								'url': 'compras/lista-oc'
							},
						]
					},*/
				]
				break;
			}

			case "Autorizador Operativo":{
				this.Jsn = [
					/*{
						'icon': 'fa-solid fa-boxes-packing',
						'title': 'Proveedores',
						'url': '/proveedores'
					},
					{
						'icon': 'fa-solid fa-list-check',
						'title': 'Aprobaciones',
						'url': '/aprobaciones'
					},
					{
						'icon': 'fa-solid fa-address-book',
						'title': 'Lista Sat',
						'url': '/lista-sat'
					},*/
					/*{
						'icon': 'fa-solid fa-cart-shopping',
						'title': 'Compras',
						'url': '/compras',
						'submenu': [
							{
								'title': 'Solicitudes de Compra',
								'url': 'compras/solicitudes-por-aprobar'
							},
							{
								'title': 'Pre-Ordenes Compra',
								'url': 'compras/solicitudes-pre-compra'
							},
							{
								'title': 'Ordenes Compra',
								'url': 'compras/lista-oc'
							},
						]
					},*/
				]
				break;
			}

			default: 
				
		}

		return this.Jsn;
		
	}
}